/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// Date-fns French locale
import { setDefaultOptions } from 'date-fns'
import { fr } from 'date-fns/locale'

setDefaultOptions({ locale: fr })

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'unfonts.css'
import '@/styles/app.scss'

const app = createApp(App)

registerPlugins(app)

app.mount('#app')
